import type { ColumnMapping } from './types';

const PROTOTYPE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

/** A mapping keyed by untrusted header names: no prototype to reach, no prototype names as keys. */
export function emptyMapping(): ColumnMapping {
  return Object.create(null) as ColumnMapping;
}

export function isOrdinaryHeader(header: string): boolean {
  return !PROTOTYPE_KEYS.has(header);
}
